import { render } from "./SchemaMoveClassification.vue?vue&type=template&id=6434657a"
import script from "./SchemaMoveClassification.vue?vue&type=script&lang=js"
export * from "./SchemaMoveClassification.vue?vue&type=script&lang=js"
script.render = render

export default script